import { render, staticRenderFns } from "./testStyle.vue?vue&type=template&id=2bbc6f24"
import script from "./testStyle.ts?vue&type=script&lang=js&external"
export * from "./testStyle.ts?vue&type=script&lang=js&external"
import style0 from "./testStyle.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports